import { container } from 'op/container';
import { compose, withHandlers, withState, withProps, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import { withAxios } from 'op/components/auth';
import { withLanguageID } from 'op/components/locale';
import { withErrorHandling } from 'op/components/error';
import { withOnlineStatus } from 'op/components/offline';


export const withPersonSeach = compose(
    withAxios,
    withLanguageID,
    withErrorHandling,
    withOnlineStatus,
    connect((state) => ({
        people: state.person.loaded || [],
    }), (dispatch) => ({
        setPeople: (people) =>
            dispatch(container.resolve('actions').set_loaded_people(people))
    })
    ),
    connect(({ auth }) => ({
        user: auth.user,
    })),
    withProps(({ people }) => ({
        ready: people.length !== 0
    })),
    withState('loading', 'setLoading', ({ ready }) => !!ready ? 'partial' : 'full'),
    withHandlers({
        fetchUsers: ({ axios, user, language, throwError, setPeople, setLoading, online }) => async () => {
            try {
                const { data } = await axios.get('/api/Employee', { "languageID": language })
                setPeople(data.map(container.resolve('transformers').person));
                setLoading(false);
            } catch (e) {
                console.log(e);
                throwError({
                    message: 'Unable to Fetch Employees',
                    details: ` 
                        ${e.message}; 
                        ${e.stack} 
                      `,
                });
            }
        }
    }),
    lifecycle({
        componentDidMount() {
            if (this.props.online) {
                this.props.fetchUsers();
            } else this.props.setLoading(false);
        }
    }),
);

export const withSearchFiltering = compose(
    withState('search', 'setSearch', ''),
    withState('unit', 'setUnit'),
    withState('job', 'setJob'),
    withState('readiness', 'setReadiness'),
    withProps(({ people, search, unit, job, readiness }) => ({
        people: people
            .filter(person =>
                (search != "" && person.id.toLowerCase().includes(search.toLowerCase())) ||
                person.name.toLowerCase().includes(search.toLowerCase())
                && (!job || person.job.name === job.name)
                && (!unit || person.unit.name === unit.name)
                // TODO: Make a ID comparison
                && (!readiness || readiness === person.readiness_level.id)
            ),
    })
    ),
)

export default {
    withPersonSeach,
    withSearchFiltering,
}